// actions
import * as actions from './actions';

const initialState = {
    count: 0,
    error: null,
    scheduled: [],
    queued: [],
    running: [],
    finished: [],
    failed: [],
    statistics: null,
    jobDetail: null,
    initial: false,
    loading: false,
    isUpdatingPending: false,
    isFetchingPending: false,
};

export default function adminReducer(state = initialState, action) {
    switch (action.type) {
        // Scheduled Jobs
        case actions.FETCH_SCHEDULED_JOBS.REQUEST:
            return { ...state, isFetchingPending: true, loading: true, error: null };

        case actions.FETCH_SCHEDULED_JOBS.SUCCESS:
            return {
                ...state,
                isFetchingPending: false,
                initial: true,
                scheduled: action.payload.data.response,
                loading: false,
                error: null
            };

        case actions.FETCH_SCHEDULED_JOBS.FAILURE:
            return { ...state, isFetchingPending: false, loading: false, error: action.payload };

        // Queued Jobs
        case actions.FETCH_QUEUED_JOBS.REQUEST:
            return { ...state, isFetchingPending: true, loading: true, error: null };

        case actions.FETCH_QUEUED_JOBS.SUCCESS:
            return {
                ...state,
                isFetchingPending: false,
                queued: action.payload.data.response,
                loading: false,
                error: null
            };

        case actions.FETCH_QUEUED_JOBS.FAILURE:
            return { ...state, isFetchingPending: false, loading: false, error: action.payload };

        // Running Jobs
        case actions.FETCH_RUNNING_JOBS.REQUEST:
            return { ...state, isFetchingPending: true, loading: true, error: null };

        case actions.FETCH_RUNNING_JOBS.SUCCESS:
            return {
                ...state,
                isFetchingPending: false,
                running: action.payload.data.response,
                loading: false,
                error: null
            };

        case actions.FETCH_RUNNING_JOBS.FAILURE:
            return { ...state, isFetchingPending: false, loading: false, error: action.payload };

        // Finished Jobs
        case actions.FETCH_FINISHED_JOBS.REQUEST:
            return { ...state, isFetchingPending: true, loading: true, error: null };

        case actions.FETCH_FINISHED_JOBS.SUCCESS:
            return {
                ...state,
                isFetchingPending: false,
                finished: action.payload.data.response,
                loading: false,
                error: null
            };

        case actions.FETCH_FINISHED_JOBS.FAILURE:
            return { ...state, isFetchingPending: false, loading: false, error: action.payload };

        // Failed Jobs
        case actions.FETCH_FAILED_JOBS.REQUEST:
            return { ...state, isFetchingPending: true, loading: true, error: null };

        case actions.FETCH_FAILED_JOBS.SUCCESS:
            return {
                ...state,
                isFetchingPending: false,
                failed: action.payload.data.response,
                loading: false,
                error: null
            };

        case actions.FETCH_FAILED_JOBS.FAILURE:
            return { ...state, isFetchingPending: false, loading: false, error: action.payload };

        // Statistics
        case actions.FETCH_STATISTICS.REQUEST:
            return { ...state, loading: true, error: null };

        case actions.FETCH_STATISTICS.SUCCESS:
            return {
                ...state,
                statistics: action.payload.data,
                loading: false,
                error: null
            };

        case actions.FETCH_STATISTICS.FAILURE:
            return { ...state, loading: false, error: action.payload };

        // Job Detail
        case actions.FETCH_JOB_DETAIL.REQUEST:
            return { ...state, loading: true, error: null };

        case actions.FETCH_JOB_DETAIL.SUCCESS:
            return {
                ...state,
                jobDetail: action.payload.data,
                loading: false,
                error: null
            };

        case actions.FETCH_JOB_DETAIL.FAILURE:
            return { ...state, loading: false, error: action.payload };

        // Remove operations
        case actions.REMOVE_SCHEDULED_JOB.REQUEST:
        case actions.REMOVE_JOB.REQUEST:
            return { ...state, isUpdatingPending: true, error: null };

        case actions.REMOVE_SCHEDULED_JOB.SUCCESS:
        case actions.REMOVE_JOB.SUCCESS:
            return { ...state, isUpdatingPending: false, error: null };

        case actions.REMOVE_SCHEDULED_JOB.FAILURE:
        case actions.REMOVE_JOB.FAILURE:
            return { ...state, isUpdatingPending: false, error: action.payload };

        // Clear operations
        case actions.CLEAR_FINISHED_JOBS.REQUEST:
        case actions.CLEAR_FAILED_JOBS.REQUEST:
            return { ...state, isUpdatingPending: true, error: null };

        case actions.CLEAR_FINISHED_JOBS.SUCCESS:
        case actions.CLEAR_FAILED_JOBS.SUCCESS:
            return { ...state, isUpdatingPending: false, error: null };

        case actions.CLEAR_FINISHED_JOBS.FAILURE:
        case actions.CLEAR_FAILED_JOBS.FAILURE:
            return { ...state, isUpdatingPending: false, error: action.payload };

        default:
            return state;
    }
};
